import { fmtDate } from "./utils";

/**
 * Patient identity + counters card at the top of the detail page.
 * Pure presentation — no handlers, no state.
 */
export default function HeaderCard({ patient, pendingCount, doneCount }) {
  return (
    <div className="bg-white border border-[#E1E9F0] rounded-2xl p-8 mb-8 grid grid-cols-[auto_1fr_auto_auto] gap-6 items-center shadow-[0_1px_3px_rgba(30,58,95,0.04)]">
      <div className="w-[68px] h-[68px] rounded-[14px] bg-[#3A8FA5] text-white flex items-center justify-center font-bold text-2xl">
        {`${(patient.first_name || "?").charAt(0)}${(patient.last_name || "").charAt(0)}`.toUpperCase()}
      </div>
      <div className="min-w-0">
        <h2 className="text-[30px] font-bold tracking-tight text-[#1E3A5F] leading-tight" data-testid="patient-full-name">
          {patient.first_name} {patient.last_name}
        </h2>
        <p className="text-[15px] text-[#5F758F] mt-1">
          Né(e) le {fmtDate(patient.date_of_birth)}
          {patient.email && <> · {patient.email}</>}
        </p>
      </div>
      <div className="px-5 py-2.5 rounded-xl bg-[#FFF3D6] border border-[#F0DDA8] text-center min-w-[92px]">
        <p className="text-[26px] font-bold text-[#D45A3F] leading-none" data-testid="pending-count">{pendingCount}</p>
        <p className="text-[11px] tracking-[0.08em] uppercase text-[#5F758F] font-semibold mt-1">En attente</p>
      </div>
      <div className="px-5 py-2.5 rounded-xl bg-[#EEF3F8] border border-[#E1E9F0] text-center min-w-[92px]">
        <p className="text-[26px] font-bold text-[#1E3A5F] leading-none" data-testid="responses-count">{doneCount}</p>
        <p className="text-[11px] tracking-[0.08em] uppercase text-[#5F758F] font-semibold mt-1">Réponses</p>
      </div>
    </div>
  );
}
